import React from 'react';
import './Properties.css';

function Properties({ language }) {
  const properties = [
    {
      name: '11711 16 Ave SW, Edmonton',
      community: 'Rutherford',
      price: '$558,000',
      description: 'Beautifully maintained 2-storey home in Rutherford. Open-concept main floor, 4 bedrooms, double attached garage. Fresh paint & new carpet (2026). Walking distance to schools, parks & shopping.',
      beds: 4,
      baths: '2.5',
      sqft: '2,024',
      image: '/images/11711 16 AVE.jpg',
      link: 'https://zsvc.paragon.ice.com/s/goto/GZWvL6T4uws',
      sold: false
    },
    {
      name: '11312 13 Ave SW, Edmonton',
      community: 'Rutherford',
      price: '$610,000',
      description: 'Stunning 2-storey home with over 2,800 sq ft of finished living space including a fully finished basement. 5 bedrooms, bonus room/loft, double attached garage. Steps from schools, parks & Henday access.',
      beds: 5,
      baths: '3.5',
      sqft: '2,153',
      image: '/images/11312 13 AVE SW.jpg',
      link: 'https://zsvc.paragon.ice.com/s/goto/Z8npaOQ_qRV',
      sold: true
    }
  ];

  return (
    <section id="properties" className="section-yellow">
      <div className="container">
        <div className="section-title-center">
          <h2>Featured Properties</h2>
          <p>Explore some of my current premium listings</p>
        </div>

        <div className="properties-grid">
          {properties.map((prop, index) => (
            <a
              key={index}
              className="property-card"
              href={prop.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div
                className="property-image"
                style={{ backgroundImage: `url('${prop.image}')` }}
              >
                {prop.sold && <div className="sold-badge">SOLD</div>}
              </div>
              <div className="property-details">
                <div className="property-community">{prop.community}</div>
                <h3>{prop.name}</h3>
                <div className="property-price">{prop.price}</div>
                <p>{prop.description}</p>
                <div className="property-features">
                  <span><i className="fas fa-bed"></i> {prop.beds} Beds</span>
                  <span><i className="fas fa-bath"></i> {prop.baths} Baths</span>
                  <span><i className="fas fa-ruler"></i> {prop.sqft} sq ft</span>
                </div>
                <div className="property-cta">View Listing →</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Properties;
